import Moment from 'moment';
import _ from 'lodash';

const debug = {
    error: false,
    dev: false,
    head: "GD.Utils"
};

import Format from "./format";
import UtilsDom from "./dom-and-react/dom";
import Convert from "./convert";
import UtilsMessage from "./message";
import DateTimeUtils from "core/gd/utils/datetime-utils";
import UtilsSet from "./set";
import TimeUtils from "./time";
import formatDateHumanize from "../format/date-humanize";
import iterateByDay from "./datetime/iterate-by-day";
import minutesToHoursMinutesString from "../format/minutes-to-hm-string";

const GDUtils = {

    Format: Format,

    Dom: new UtilsDom(),

    Convert: Convert,

    Message: new UtilsMessage(),

    Time: new TimeUtils(),

    search(haystack, needle) {
        return (haystack.toLowerCase().includes(needle.toLowerCase()));
    },

    objectToOptions(obj) {

        var res = [];

        _.forEach(obj,function(label,key) {

            var value = key;
            if (parseInt(key)>=0) value = parseInt(key);

            res.push({
                value: value,
                label: label
            });

        });
        return res;
    },

    copyToClipboard(str) {
        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = str;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =
            document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                ? document.getSelection().getRangeAt(0)     // Store selection if found
                : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
            document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
            document.getSelection().addRange(selected);   // Restore the original selection
        }
    },

    nameColor(name) {

        const letter = gd.utils.initials(name,1).toLowerCase();

        if (gd.const.alphabetColors[letter]) {
            return gd.const.alphabetColors[letter];
        } else {
            return gd.const.alphabetColors.a;
        }

    },

    nameColorClass(name) {
        const letter = gd.utils.initials(name,1).toLowerCase();
        return gd.const.alphabetColors[letter] ? letter : "a";
    },


    getDefaultView(systemType, value = null) {
        const { PROJECT, WORKFOLDER, BACKLOG, SPRINT, TAG } = gd.const.project.type;

        let res = value;

        switch(systemType){
            case PROJECT:       if(!res) res = "tasks_list"; break;
            case WORKFOLDER:    if(!res) res = "tasks_list"; break;
            case BACKLOG:       if(!["tasks_list","board","summary"].includes(res)) res = "tasks_list"; break;
            case SPRINT:        if(!res) res = "board"; break;
            case TAG:           if(!["tasks_list","board","summary"].includes(res)) res = "tasks_list"; break;
            default:            res = "tasks_list"; break;
        }

        return res ? res : "tasks_list";
    },

    formatMenuCounter(total,isItNewCounter) {
        if (total<10 && isItNewCounter) {
            return "+"+total;
        }
        if (total>99) {
            return "99+";
        }
        return total;
    },

    // Depricated - est problemi s drugimi shirftami ne english ... use css text transformation
    strToTitleCase: function(str)
    {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    },


    howOldFormatted: function(creationMoment) {

        console.error('depricated - utils.hodOld');

        if (creationMoment._isUTC==false) creationMoment = Moment.utc(creationMoment);

        var ms = Moment.utc().diff(creationMoment);

        var duration = Moment.duration(ms);


        if (duration.months()>3) return duration.months()+"+ months ago";
        if (duration.days()>1) return duration.days()+" days ago";
        if (duration.days()==1) return "Yesterday";
        return "Today";

        /*var s = Math.floor(duration.asHours()) + Moment.utc(ms).format(":mm:ss");

        return s;*/
    },

    localMoment(momentUTC) {

        console.error("Depricated");

        if (momentUTC._isUTC==false) {
            if (debug.error) console.warn(debug.head,".localMoment() Passed argument is not UTC",momentUTC);
            momentUTC = Moment.utc(momentUTC);
        }

        return momentUTC.tz(gd.session.me.timezone);
    },

    momentIntervalHumanize(momentInterval) {

        if (momentInterval.years()>0) return (momentInterval.years()>1)?momentInterval.years()+" years":momentInterval.years()+" year";

        if (momentInterval.months()>0 || momentInterval.days()>0) return (momentInterval.asDays()>1)?Math.round(momentInterval.asDays())+" days":" day";

        if (momentInterval.hours()>0) return (momentInterval.hours()>1)?momentInterval.hours()+" hours":" hour";

        if (momentInterval.minutes()>1) return momentInterval.minutes()+" min";

        return "1 min";
    },

    momentHumanize(moment,format) {

        console.warn("Depricated. Use formatDateHumanize()")

        return formatDateHumanize(moment, format)

        // var localNow = Moment();
        //
        // if (localNow.isSame(moment, 'day')) {
        //     return "Today";
        // }
        //
        // var localYesterday = Moment().subtract(1,"days");
        // if (localYesterday.isSame(moment, 'day')) {
        //     return "Yesterday";
        // }
        //
        // var localTomorrow = Moment().add(1,"days");
        // if (localTomorrow.isSame(moment, 'day')) {
        //     return "Tomorrow";
        // }
        //
        // return moment.format(format);

    },

    localWhen: function(moment) {

        var agoString = "";
        //var agoString = " ago";

        if (moment._isUTC==true) {
            if (debug.error) console.warn(debug.head,".localWhen() Passed argument is  UTC",moment);
            moment.local();
        }

        var localMoment = moment; //gd.utils.localMoment(momentUTC);
        var localNow = Moment(); //gd.utils.localMoment(Moment.utc());

        //check if today
        if (localNow.isSame(localMoment, 'day')) {
            return "Today";
        }

        // check if yesterday
        var localYesterday = Moment().subtract(1,"days"); //gd.utils.localMoment(Moment.utc().subtract(1,"days"));
        if (localYesterday.isSame(localMoment, 'day')) {
            return "Yesterday";
        }

        var diff = Moment.duration(localNow.diff(localMoment)); // 'a month'
        var diffYears = diff.years();
        var diffMonths = diff.months();
        var diffDays = diff.days();

        var resultString = "";
        if (diffYears>0) {
            resultString = diffYears+"y";
            if (diffMonths>0) resultString+=" "+diffMonths+"m";
            return resultString + agoString;
        }

        if (diffMonths>0) {
            resultString = diffMonths+"m";
            if (diffDays>0) resultString+=" "+diffDays+"d";
            return resultString + agoString;
        }

        if (diffDays<2) diffDays = 2; //hack-fix becuase if it was yesterday it would be there and when we compare we dont' check hours
        return diffDays+" days" + agoString;
    },

    // nl2br: function(str, is_xhtml) {
    //     var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    //     return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    // },

    initials(str,max) {

        if (!str) return "A"; // patch there were problems

        let arr = str.trim().split(" ");
        let res = arr[0][0];
        if (max>1 && arr[1]) res+=arr[1][0];
        if (max>2 && arr[2]) res+=arr[2][0];

        return res.toUpperCase();
    },

    guid: function() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    },

    /**
     * Returns random number between min & max
     * @param max
     * @param min
     * @returns {number}
     */
    randomInt(max = 1000, min = 300) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    normalizeInt(value, options = {min: 0, max: 1}) {
        let res = value;
        if (!_.isNil(options.min) && res < options.min) res = options.min;
        else if (!_.isNil(options.max) && res > options.max) res = options.max;
        return res;
    },

    humanTime(value, type = GDUtils.TYPE_MINUTES, options = {}) {
        const minuteLabel =     _.get(options, 'minuteLabel', 'm');
        const minutesLabel =    _.get(options, 'minutesLabel', 'm');
        const hourLabel =       _.get(options, 'hourLabel', 'h');
        const hoursLabel =      _.get(options, 'hoursLabel', 'h');
        const dayLabel =        _.get(options, 'dayLabel', 'd');
        const daysLabel =       _.get(options, 'daysLabel', 'd');

        const getLabel = (value, type) => {
            let res;
            switch (type) {
                case 'minutes': res = value > 1 ? minutesLabel : minuteLabel; break;
                case 'hours':   res = value > 1 ? hoursLabel : hourLabel; break;
                case 'days':    res = value > 1 ? daysLabel : dayLabel; break;
            }
            return ' ' + res;
        }

        let duration;
        switch (type) {
            case this.TYPE_MINUTES: duration = Moment.duration(value, 'minutes'); break;
            case this.TYPE_SECONDS: duration = Moment.duration(value, 'seconds'); break;
            case this.TYPE_HOURS:   duration = Moment.duration(value, 'hours'); break;
        }

        let humanTime = '';
        if (duration.asHours() < 1) {
            humanTime = duration.minutes() + getLabel(duration.minutes(),'minutes');
        } else if (duration.asDays() < 1) {
            humanTime = duration.hours() + getLabel(duration.hours(),'hours') + ' ' + duration.minutes() + getLabel(duration.minutes(),'minutes');
        } else if (duration.asDays() > 1 && duration.asDays() <= 15) {
            humanTime = duration.days() + getLabel(duration.hours(),'days') + ' ' + getLabel(duration.hours(),'hours');
        } else {
            humanTime = Math.floor(duration.asDays()) + ' ' + getLabel(Math.floor(duration.asDays()),'days')
        }

        return humanTime;
    },

    humanTimeShort(value, type = GDUtils.TYPE_MINUTES, options = {}) {
        const minuteLabel =     _.get(options, 'minuteLabel', 'm');
        const minutesLabel =    _.get(options, 'minutesLabel', 'm');
        const hourLabel =       _.get(options, 'hourLabel', 'h');
        const hoursLabel =      _.get(options, 'hoursLabel', 'h');
        const dayLabel =        _.get(options, 'dayLabel', 'd');
        const daysLabel =       _.get(options, 'daysLabel', 'd');

        const getLabel = (value, type) => {
            let res;
            switch (type) {
                case 'minutes': res = value > 1 ? minutesLabel : minuteLabel; break;
                case 'hours':   res = value > 1 ? hoursLabel : hourLabel; break;
                case 'days':    res = value > 1 ? daysLabel : dayLabel; break;
            }
            return ' ' + res;
        }

        let duration;
        switch (type) {
            case this.TYPE_MINUTES: duration = Moment.duration(value, 'minutes'); break;
            case this.TYPE_SECONDS: duration = Moment.duration(value, 'seconds'); break;
            case this.TYPE_HOURS:   duration = Moment.duration(value, 'hours'); break;
        }

        let humanTime = '';
        if (duration.asHours() < 1) {
            humanTime = duration.minutes() + getLabel(duration.minutes(),'minutes');
        } else if (duration.asDays() < 1) {
            const hours = duration.hours() + this.roundToDecimals(duration.minutes()/60, 2)
            humanTime = hours + getLabel(hours,'hours');
        } else if (duration.asDays() > 1 && duration.asDays() <= 15) {
            const days = duration.days() + this.roundToDecimals(duration.hours() / 24, 2);
            humanTime = days + getLabel(days,'days');
        } else {
            humanTime = this.roundToDecimals(duration.asDays(), 2) + ' ' + getLabel(this.roundToDecimals(duration.asDays(), 2),'days')
        }

        return humanTime;
    },

    /**
     * Display +[plus] before int
     * @param number
     * @returns {string}
     */
    displayNumber(number) {
        return (number > 0 ? '+' : '') + number;
    },

    /**
     * Test data to compose dateRange API object {{data: value, data: value}}
     * @param dateRange
     * @param max
     * @param min
     * @returns {{}}
     */
    dateRangeData: function (dateRange, max = 100, min = 1) {
        var result = {};

        iterateByDay(dateRange, moment => {
            const dateFormatted = moment.format('YYYY-MM-DD');
            result[dateFormatted] = gd.utils.randomInt(max, min);
        })
        // dateRange.by('days', moment => {
        //     var dateFormatted = moment.format('YYYY-MM-DD');
        //     result[dateFormatted] = gd.utils.randomInt(max, min);
        // });

        return result;
    },

    minutesHumanize(minutes, separator = '') {

        const m = minutes % 60;
        const h = (minutes - m)/60;

        if (h<1) return m+" minutes";
        if (m<1) return (h>1)?h+" hours":"1 hour";
        return h + "h. " + separator + m +"m.";
    },

    minutesHumanizeWithDays(minutes) {

        var h=0, m=0, d=0;

        m = minutes % 60;

        var roundHours = (minutes - m)/60;

        if (roundHours>24) {

            h = roundHours % 24;
            d = (roundHours-h)/24;

        } else {
            h = roundHours;
        }

        var res;

        if (d>0) {
            res = d + "d.";
            if (h>0) res+=" "+h+" h.";
            return res;
        } else {
            if (h<1) return m+" minutes";
            if (m<1) return h+" hours";
            return h + "h. "+ m +"m.";
        }



    },

    minutesToHM(minutes) {
        const mins = minutes % 60;
        const hours = (minutes - mins) / 60;

        return {
            hours,
            mins,
            minutes: mins
        }
    },

    minutesToHMStr(minutes, hoursPostfix = "h.", minutesPostfix = "m.", separator = '', forceShow = false) {
        return minutesToHoursMinutesString(minutes, hoursPostfix , minutesPostfix, separator, forceShow)
    },

    roundNumberTo05(number) {
        var lastDigit = number % 10;

        var main = (number - lastDigit) / 10;



        if (lastDigit<3) lastDigit = 0;
        else if (lastDigit<8) lastDigit = 5;
        else if (lastDigit>=8) {
            lastDigit = 0;
            main+=1;
        }

        var res = main * 10 + lastDigit;
        return res;
    },

    roundToDecimals(number, decimals = 0) {
        const multiplier = Math.pow(10,decimals);
        return Math.round(number * multiplier)/multiplier;
    },

    floorToDecimals(number, decimals = 0) {
        const multiplier = Math.pow(10,decimals);
        return Math.floor(number * multiplier)/multiplier;
    },

    calculateChangePercentage(oldValue, newValue) {
        return Math.ceil((newValue - oldValue)/ (oldValue/100));
    },

    momentToDate(moment) {
        if (moment) return moment.format("YYYY-MM-DD");
        else return null;
    },

    generateShortName(name) {
        let arr = name ? name.split(" ") : [];

        let shortName = "";
        arr && arr.map((word, key) => {
            if (key >= 3 || !word[0]) return;
            shortName += word[0].toUpperCase();
        });

        return shortName;
    },

    leadingZero(num, size) {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    },

    toggleSetValue(set, value) {
        return UtilsSet.toggleValue(set, value);
    },

    // copied to ArrayUtils
    toggleArrayValue(arr, value, options) {
        let newArr = arr.slice();
        if (newArr.includes(value)) newArr.remove(value);
        else newArr.push(value);

        if (options && options.mandatorySelection && newArr.length === 0) newArr = arr.slice();

        return newArr;
    },

    // copied to ArrayUtils
    toggleArrayObject(arr, object, searchFunc, options) {
        let newArr = arr.slice();
        const found = newArr.find(searchFunc);
        if (found) newArr.remove(found);
        else newArr.push(object);

        if (options && options.mandatorySelection && newArr.length === 0) newArr = arr.slice();

        return newArr;
    },

    // copied to ArrayUtils
    addValueToArray(array, value) {
        if (value && !array.includes(value)) {
            array.push(value);
        }

        return array;
    },

    // copied to ArrayUtils
    removeValueFromArray(array, value) {
        const index = array.indexOf(value);
        if (index !== -1) {
            array.splice(index, 1);
        }

        return array;
    },

    // copied to ArrayUtils
    moveInArrayMutate(array, from, to) {
        const startIndex = from < 0 ? array.length + from : from;

        if (startIndex >= 0 && startIndex < array.length) {
            const endIndex = to < 0 ? array.length + to : to;

            const [item] = array.splice(from, 1);
            array.splice(endIndex, 0, item);
        }
    },

    // copied to ArrayUtils
    moveInArray(array, from, to) {
        array = [...array];
        this.moveInArrayMutate(array, from, to);
        return array;
    },

    getFileSize(size, asObject=false) {
        let cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
        selectedSize = 0;
        selectedUnit = "b";
        if (size > 0) {
            units = ['Tb', 'Gb', 'Mb', 'Kb', 'b'];
            for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
                unit = units[i];
                cutoff = Math.pow(1024, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(1024, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10;
        }

        if (asObject) {
            return {
                value: selectedSize,
                units: selectedUnit
            }
        } else {
            return selectedSize + "" + selectedUnit;
        }
    },

    openCenteredWindow(url, title, w, h) {
        // Fixes dual-screen position                               Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft  : screen.left;
        const dualScreenTop =   window.screenTop !== undefined ? window.screenTop   : screen.top;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const left = ((width / 2) - (w / 2)) + dualScreenLeft;
        const top = ((height / 2) - (h / 2)) + dualScreenTop;
        const newWindow = window.open(url, title,
            'directories = 0, titlebar = 0, toolbar = 0, location = url, ' +
            'status = 0, menubar = 0, scrollbars = false, resizable = false, ' +
            'width = ' + w + ', height = ' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    },

   checkIsArray(o) {
        return Object.prototype.toString.call(o) === '[object Array]';
   },

    valueChecker(a, b, strict = false){
        const { checkIsArray } = gd.utils;
        let result;
        if (checkIsArray(b)) {
            if (checkIsArray(a)) {
                result = strict ? _.intersection(b,a).length === b.length : _.intersection(b,a).length > 0;
            } else {
                result = b.includes(a);
            }
        } else {
            result = checkIsArray(a) ? a.includes(b) : b === a;
        }
        return result;
    },

    compare(n1,n2) {
        return n1.trim().toLowerCase() === n2.trim().toLowerCase();
    },

    formatTimeSpent(minutes, roundHours=40, delimiterHours=1000) {
        let { hours, mins } = gd.utils.minutesToHM(parseInt(minutes));
        if (hours >= roundHours) {
            if (mins >= 30) hours++;
            mins = 0;
        }
        if (hours >= delimiterHours) {
            hours = hours.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        let res = '';
        if (hours) res = hours + 'h. ';
        if (mins) res += mins + 'm.';
        return res;
    },

    numberOfWeekdaysBetween(d1, d2, isoWeekdays = [1,2,3,4,5,6,7]) {
        const date1 = Moment(d1);
        const date2 = d2 ? Moment(d2) : Moment(d1);
        let current = date1.clone();
        let count = 0;
        while (current.isBefore(date2, 'day') || current.isSame(date2, 'day')) {
            if (isoWeekdays.includes(current.isoWeekday())) count++;
            current.add(1,'day');
        }

        return count;
    },

    addWeekdays(date, days, isoWeekdays = [1,2,3,4,5]) {
        let currentDate = Moment(date);
        if (days === 0) {/*do nothing*/}
        else if (days > 0) {
            while (days > 0) {
                currentDate.add(1,'day');
                if (isoWeekdays.includes(currentDate.isoWeekday())) days--;
            }
        } else {
            while (days < 0) {
                currentDate.subtract(1,'day');
                if (isoWeekdays.includes(currentDate.isoWeekday())) days++;
            }
        }

        return currentDate;
    },

    getDecimal(num) {
        let str = "" + num;
        const zeroPos = str.indexOf(".");
        if (zeroPos === -1) return 0;
        str = str.slice(zeroPos);
        return +str;
    },

    captureErrorMessage(title, errorData) {
        if (typeof Sentry !== "undefined") {
            Sentry.withScope((scope) => {
                scope.setLevel(errorData.level);
                errorData.extra && _.mapKeys(errorData.extra, (value, key)=>{
                    scope.setExtra(key, value);
                });
                Sentry.captureMessage(title);
            });
        } else {
            console.error(title, errorData);
        }
    },

    helpUrl(articleKey) {
        return 'https://www.goodday.work/help/'+gd.const.help.articles[articleKey];
    },

    openHelp(articleKey) {
        if (articleKey?.substr(0,8) === 'article.') {
            articleKey = articleKey.substr(8);
            window.open(gd.utils.helpUrl(articleKey));
        } else {
            console.error('unknown help key');
            window.open('https://www.goodday.work/help/');
        }
    },

    openVideo(videoKey) {
        window.open(gd.utils.youtubeUrl(videoKey))
    },

    youtubeUrl(videoKey) {
        return 'https://www.youtube.com/watch?v='+gd.const.video[videoKey];
    },

    convertNameToId(value) {
        return value ? value.trim().toLowerCase().split(' ').join('_') : null;
    },

    getTextWidth(text, fontSize = 12, fontFamily, style = {}) {
        const textContainer = document.createElement('div');
        textContainer.textContent = text
        textContainer.style.position = 'absolute';
        textContainer.style.visibility = 'hidden';
        textContainer.style.height = 'auto';
        textContainer.style.width = 'auto';
        textContainer.style.whiteSpace = 'nowrap';

        textContainer.style.fontSize = fontSize + 'px';
        if (fontFamily) textContainer.style.fontFamily = fontFamily;

        _.mapKeys(style, (value, key) => {
            textContainer.style[key] = value;
        })

        document.body.appendChild(textContainer);
        const width = textContainer.clientWidth;
        document.body.removeChild(textContainer);

        return width
    },

    getTextExceedsNodeWidth(text, node, padding = 0, fontSize = 12, fontFamily, style = {}) {
        const textWidth = Math.round(this.getTextWidth(text, fontSize, fontFamily, style));
        return textWidth > node.clientWidth - padding
    },

    getImageDimensions(url, callback, error) {
        const imgContainer = document.createElement('img');
        imgContainer.style.position = 'absolute';
        imgContainer.style.visibility = 'hidden';
        imgContainer.style.height = 'auto';
        imgContainer.style.width = 'auto';

        imgContainer.addEventListener('load', function() {
            callback(this.width, this.height);
        });
        imgContainer.addEventListener('error', function(e) {
            if (error) error(e);
        });

        imgContainer.src = url;
    },

    getObjectDiff(obj1, obj2) {
        if (!obj1) obj1 = {};
        if (!obj2) obj2 = {};
        return Object.keys(obj1).reduce((result, key) => {
            if (!obj2.hasOwnProperty(key)) {
                result.push(key);
            } else if (_.isEqual(obj1[key], obj2[key])) {
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(obj2));
    },

    objectDifference(object, base) {
        const changes = (object, base) => {
            return _.transform(object, (result, value, key)=>{
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        };
        return changes(object, base);
    },

    trimMessageRTF(messageRTF) {
        if (messageRTF && !messageRTF.v) {
            let blocks = messageRTF.blocks.slice();
            const indexesToRemove = [];
            let startTrimmed = false;
            for(let i=0; i < blocks.length; i++) {
                if (!startTrimmed && !blocks[i].text && blocks[i].type === "unstyled") indexesToRemove.push(i);
                else startTrimmed = true;
            }

            let endTrimmed = false;
            for(let i = blocks.length-1; i >= 0; i--) {
                if (!endTrimmed && !blocks[i].text && blocks[i].type === "unstyled") indexesToRemove.push(i);
                else endTrimmed = true;
            }

            messageRTF.blocks = _.filter(messageRTF.blocks, (b,key)=>!indexesToRemove.includes(key));
        }
        return messageRTF;
    },

    getTypeByMime(mimeType) {
        const gd_file_types = {
            'application/zip': gd.const.attachment.fileType.ARCHIVE,

            'image/bmp': gd.const.attachment.fileType.IMAGE,
            'image/vnd.xiff': gd.const.attachment.fileType.IMAGE,
            'image/gif': gd.const.attachment.fileType.IMAGE,
            'image/jpeg': gd.const.attachment.fileType.IMAGE,
            'image/x-pcx': gd.const.attachment.fileType.IMAGE,
            'image/x-pict': gd.const.attachment.fileType.IMAGE,
            'image/png': gd.const.attachment.fileType.IMAGE,
            'image/tiff': gd.const.attachment.fileType.IMAGE,

            'image/x-cmx': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/vnd.dwg': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/x-freehand': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/x-icon': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/vnd.adobe.photoshop': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/svg+xml': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'image/vnd.dxf': gd.const.attachment.fileType.GRAPHIC_SOURCE,
            'application/postscript': gd.const.attachment.fileType.GRAPHIC_SOURCE,

            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': gd.const.attachment.fileType.DOCUMENT,
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': gd.const.attachment.fileType.DOCUMENT,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': gd.const.attachment.fileType.DOCUMENT,

            'application/vnd.google-apps.document': gd.const.attachment.fileType.GOOGLE_DOCUMENT,
            'application/vnd.google-apps.spreadsheet': gd.const.attachment.fileType.GOOGLE_DOCUMENT,
            'application/vnd.google-apps.drawing': gd.const.attachment.fileType.GOOGLE_DOCUMENT,
            'application/vnd.google-apps.form': gd.const.attachment.fileType.GOOGLE_DOCUMENT,
            'application/vnd.google-apps.presentation': gd.const.attachment.fileType.GOOGLE_DOCUMENT,
            'application/vnd.google-apps.fusiontable': gd.const.attachment.fileType.GOOGLE_DOCUMENT
        };

        return gd_file_types[mimeType] ? gd_file_types[mimeType] : gd.const.attachment.fileType.OTHER;
    },

    shallowClone(obj) {
        return Object.create(
            Object.getPrototypeOf(obj),
            Object.getOwnPropertyDescriptors(obj)
        );
    },

    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    // not in use
    generateUIDShort() {
        // I generate the UID from two parts here
        // to ensure the random number provide enough bits.
        var firstPart = (Math.random() * 46656) | 0;
        var secondPart = (Math.random() * 46656) | 0;
        firstPart = ("000" + firstPart.toString(36)).slice(-3);
        secondPart = ("000" + secondPart.toString(36)).slice(-3);
        return firstPart + secondPart;
    },


    generateUIDWithCollisionChecking(arrayIds = []) {

        // array to object
        const _generatedUIDs = arrayIds.reduce((a, key) => Object.assign(a, { [key]: 0 }), {});

        while (true) {
            var uid = ("0000" + ((Math.random() * Math.pow(36, 4)) | 0).toString(36)).slice(-4);
            if (!_generatedUIDs.hasOwnProperty(uid)) {
                _generatedUIDs[uid] = true;
                return uid;
            }
        }
    },

    validateEmail(mail) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
    },

    isValidURL(value) {
        const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(value);
    },

    isImageURL(value) {
        const pattern = new RegExp('(https?:\/\/)?(.+\.(png|jpg|jpeg|gif|svg))','i'); // fragment locator
        return !!pattern.test(value);
    },

    findEarliestStartDate(items) {
        const startDates = _(items).map(i=>i.startDate ? DateTimeUtils.dateToMoment(i.startDate).format('X') : null).compact().value();
        return startDates.length > 0 ? Moment.unix(_.min(startDates)) : Moment();
    },
};


Object.defineProperty(GDUtils, 'TYPE_MINUTES', {
    value: 'minutes',
    writable: false,
    enumerable: true,
    configurable: true
});

Object.defineProperty(GDUtils, 'TYPE_HOURS', {
    value: 'hours',
    writable: false,
    enumerable: true,
    configurable: true
});

Object.defineProperty(GDUtils, 'TYPE_SECONDS', {
    value: 'seconds',
    writable: false,
    enumerable: true,
    configurable: true
});

module.exports = GDUtils;
